import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import FormDuuf, {
  FormDuufGroup,
  FormDuufSubmit,
  useFormDuuf,
} from '@ubo/form-duuf'

import Loading from './shared/Loading'

import ParseContent from './shared/ParseContent'

export { FormDuufGroup, FormDuufSubmit, useFormDuuf }

function Form({ className = '', children, ...rest }) {
  const { allGfForm } = useStaticQuery(graphql`
    query formDuufQuery {
      allGfForm {
        edges {
          node {
            formId
            slug
            apiURL
            formFields {
              id
              label
              labelPlacement
              type
              isRequired
              visibility
              placeholder
              choices
              description
            }
            button {
              text
            }
            confirmations {
              message
            }
          }
        }
      }
    }
  `)

  return (
    <FormDuuf
      className={className}
      {...rest}
      graphqlData={allGfForm}
      loadingComponent={Loading}
      contentComponent={ParseContent}
      renderLoading={() => <Loading />}
      renderStatus={({ content }) => <ParseContent content={content || ''} />}
    >
      {children}
    </FormDuuf>
  )
}

export default Form
